export enum PhasesPermissions {
  Phases = 'phases'
}
